var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.75 -0.75 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.9434375 17.667187499999997c-0.36900937500000003 -0.08737500000000001 -0.7038187499999999 -0.2821875 -0.9620812499999999 -0.5598749999999999 -0.25826625000000003 -0.27768750000000003 -0.42838125 -0.6256875 -0.4888321875 -1.00003125 -0.060450937499999996 -0.3744375 -0.008522812500000001 -0.75825 0.14921718750000001 -1.10315625 0.1577390625 -0.3448125 0.4142025 -0.63515625 0.736955625 -0.83428125 0.32276249999999995 -0.19903125 0.6973031249999999 -0.2979375 1.07626875 -0.28415625 0.378965625 0.01378125 0.745321875 0.1396875 1.0527374999999999 0.3616875 0.307425 0.22209375 0.542090625 0.53025 0.6743343749999999 0.88565625 0.13223437500000002 0.35540625 0.15610312499999998 0.7421249999999999 0.0685875 1.1110312500000001 -1.5675 -1.0565625 -2.4431249999999998 -0.785625 -2.3071875 1.423125Z",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.4171875 0.46875h9.665625c0.49724999999999997 0 0.97415625 0.19754437500000002 1.3258124999999998 0.5491781250000001 0.35165625 0.351628125 0.5491874999999999 0.82854375 0.5491874999999999 1.325821875v4.3546875H4.5421875V2.34375c0 -0.49727812499999996 0.19755 -0.97419375 0.5491781250000001 -1.325821875C5.44299375 0.666294375 5.919909375 0.46875 6.4171875 0.46875v0Z",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.957812500000003 9.5728125c0 1.779 -0.7066875 3.4851562499999997 -1.964625 4.7431875C14.73515625 15.573937500000001 13.029 16.280625 11.25 16.280625c-1.779 0 -3.485175 -0.7066875 -4.7431406250000006 -1.964625C5.248903125 13.05796875 4.5421875 11.3518125 4.5421875 9.5728125V6.69845625h13.415625V9.5728125Z",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M9.140625 3.984375c-0.129440625 0 -0.234375 -0.104934375 -0.234375 -0.234375s0.104934375 -0.234375 0.234375 -0.234375",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M9.140625 3.984375c0.129440625 0 0.234375 -0.104934375 0.234375 -0.234375s-0.104934375 -0.234375 -0.234375 -0.234375",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M13.359375 3.984375c-0.12946875 0 -0.234375 -0.104934375 -0.234375 -0.234375s0.10490625 -0.234375 0.234375 -0.234375",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M13.359375 3.984375c0.12946875 0 0.234375 -0.104934375 0.234375 -0.234375s-0.10490625 -0.234375 -0.234375 -0.234375",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.26 9.241790625H9.240928125c-0.5177625 0 -0.9375 0.419709375 -0.9375 0.937490625v1.6612500000000001c0 0.51778125 0.4197375 0.9375 0.9375 0.9375H13.26c0.51778125 0 0.9375 -0.41971875 0.9375 -0.9375v-1.6612500000000001c0 -0.51778125 -0.41971875 -0.937490625 -0.9375 -0.937490625Z",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.209071875 15.96459375 -0.855 5.1075c0.000121875 0.12590625 -0.024571875 0.25059375 -0.072665625 0.3669375 -0.04809375 0.11634375 -0.11865 0.22209375 -0.2076375 0.31115624999999997 -0.08897812499999999 0.0890625 -0.19464375 0.15975 -0.31094999999999995 0.2079375 -0.11630625 0.0481875 -0.240975 0.07303124999999999 -0.366871875 0.07303124999999999h-3.6834374999999997c-0.16318125 0.0001875 -0.323578125 -0.04228125 -0.46531875 -0.12309375 -0.14175 -0.08090625 -0.25994062500000004 -0.19734374999999998 -0.342890625 -0.337875 -0.08295 -0.1404375 -0.127790625 -0.3001875 -0.13007812500000002 -0.46340625 -0.0022875 -0.163125 0.038053125 -0.32409375 0.1170375 -0.466875 0.24850312499999996 -0.44962500000000005 0.61299375 -0.8245312499999999 1.0555312499999998 -1.0855312499999998 0.44253750000000003 -0.261 0.946940625 -0.398625 1.46071875 -0.39853125h0.7631249999999999l0.81375 -4.40625",
    strokeWidth: 1.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.1459375 13.8853125c-0.332775 -0.44390625 -0.55696875 -0.9595312500000001 -0.6546375 -1.50571875 -0.09766875 -0.54609375 -0.06609374999999999 -1.10746875 0.09219374999999999 -1.63921875 0.1582875 -0.5317500000000001 0.43889062500000003 -1.0190625 0.8193374999999999 -1.4228156250000001 0.38045625 -0.4038 0.850171875 -0.71289375 1.3715437499999998 -0.90253125l0.7678125 -0.28125",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.5565625 17.667187499999997c0.369 -0.08737500000000001 0.70378125 -0.2821875 0.9620625 -0.5598749999999999 0.25828125 -0.27768750000000003 0.4284375 -0.6256875 0.4888125 -1.00003125 0.06046875 -0.3744375 0.00853125 -0.75825 -0.14915625 -1.10315625 -0.15778125 -0.3448125 -0.41418750000000004 -0.63515625 -0.7369687500000001 -0.83428125 -0.32278125 -0.19903125 -0.6973125 -0.2979375 -1.07625 -0.28415625 -0.37903125 0.01378125 -0.7453125 0.1396875 -1.05271875 0.3616875 -0.3075 0.22209375 -0.54215625 0.53025 -0.67434375 0.88565625 -0.13228125000000002 0.35540625 -0.15609375 0.7421249999999999 -0.068625 1.1110312500000001 1.68375 -1.089375 2.4778124999999998 -0.6590625 2.3071875 1.423125Z",
    strokeWidth: 1.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.354062499999998 13.8853125c0.33281249999999996 -0.44390625 0.55696875 -0.9595312500000001 0.65465625 -1.50571875 0.0976875 -0.54609375 0.06609374999999999 -1.10746875 -0.09225 -1.63921875 -0.15825 -0.5317500000000001 -0.43884375000000003 -1.0190625 -0.81928125 -1.4228156250000001 -0.3804375 -0.4038 -0.85021875 -0.71289375 -1.3715625 -0.90253125l-0.7678125 -0.28125",
    strokeWidth: 1.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.170625 19.156031249999998s2.1834375 0.3028125 2.1834375 1.91625",
    strokeWidth: 1.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.639375 17.18353125 2.225625 0.834375",
    strokeWidth: 1.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.2909375 15.96459375 0.855 5.1075c-0.00009375 0.12590625 0.0245625 0.25059375 0.07265625 0.3669375 0.04809375 0.11634375 0.11868749999999999 0.22209375 0.20765625000000001 0.31115624999999997 0.08896875 0.0890625 0.194625 0.15975 0.31096875 0.2079375 0.11624999999999999 0.0481875 0.2409375 0.07303124999999999 0.36684374999999997 0.07303124999999999h3.6834374999999997c0.16321875 0.0001875 0.32353125 -0.04228125 0.46528125000000004 -0.12309375 0.14175 -0.08090625 0.25996874999999997 -0.19734374999999998 0.3429375 -0.337875 0.08296875 -0.1404375 0.12778125 -0.3001875 0.13003125 -0.46340625 0.00234375 -0.163125 -0.0380625 -0.32409375 -0.11699999999999999 -0.466875 -0.24853125 -0.44962500000000005 -0.61303125 -0.8245312499999999 -1.0555312499999998 -1.0855312499999998 -0.4425 -0.261 -0.94696875 -0.398625 -1.46071875 -0.39853125h-0.7631249999999999l-0.81375 -4.40625",
    strokeWidth: 1.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.329375 19.156031249999998s-2.1834375 0.3028125 -2.1834375 1.91625",
    strokeWidth: 1.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.860624999999999 17.18353125 -2.225625 0.834375",
    strokeWidth: 1.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5421875 3.75h2.4834375",
    strokeWidth: 1.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.957812500000003 3.75h-2.4834375",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/robot-icon.79936406.svg";
export { ForwardRef as ReactComponent };